import { render, staticRenderFns } from "./RegistrationFundingProjectsStep.vue?vue&type=template&id=7dd5b281&"
import script from "./RegistrationFundingProjectsStep.vue?vue&type=script&lang=ts&"
export * from "./RegistrationFundingProjectsStep.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports